import { SaveOutlined, SendOutlined } from '@ant-design/icons';
import { NgayPhepTrongNam } from '@app/models/donnghiphep/NgayPhepTrongNam';
import { NgayNghiInfo } from '@app/models/setting/Setting';
import { layDSNgayNghiLe, layNgayNghiTrongTuan } from '@app/services/setting';
import { Button, Col, DatePicker, Form, Row, Space, Table, Tabs } from 'antd';
import { useForm } from 'antd/es/form/Form';
import Column from 'antd/es/table/Column';
import { Input } from 'antd/lib';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { loaiNgayNghi, loaiNghiPhep, trangThaiDonNghiPhep } from '../../constants';
import { Links } from '../../helpers/Links';
import { dateCommon, validateMessages } from '../../helpers/common';
import { layChiTiet, layDsNghiPhepTrongNamTheoNhanVien, layNguoiPheDuyet_YKienPhepMacDinh, luuDonNghiPhep } from '../../services/donnghiphep';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import BanGiamDocSelectBox from '../utils/BanGiamDocSelectBox';
import LoaiNghiPhepSelectBox from '../utils/LoaiNghiPhepSelectBox';
import NhanVienPhongBanSelectBox from '../utils/NhanVienPhongBanSelectBox';
import BanChapHanhCongDoanSel from '../utils/BanChapHanhCongDoanSel';

const ChiTietPhep = () => {
    const { TextArea } = Input;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const [form] = useForm();
    const [idNguoiYKien, setIdNguoiYKien] = useState(0);
    const [tenNhanVien, setTenNhanVien] = useState<string>(user.hoTen);
    const [tongSoNgayNghi, setTongSoNgayNghi] = useState<number>(0);
    const [trinhLanhDao, setTrinhLanhDao] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [ngayNghiTrongTuan, setNgayNghiTrongTuan] = useState<number[]>([]);
    const [dsNgayNghiLe, setDsNgayNghiLe] = useState<NgayNghiInfo[]>([]);
    const [dsNgayLamBu, setDsNgayLamBu] = useState<NgayNghiInfo[]>([]);
    const [dsNgayPhepTrongNam, setDSNgayPhepTrongNam] = useState<Array<NgayPhepTrongNam>>([]);
    const [idLoaiNghiPhep, setIdLoaiNghiPhep] = useState<number>(0);
    const [enabledNYK2, setEnsabledNYK2] = useState<boolean>(false);
    const [enabledNYK3, setEnsabledNYK3] = useState<boolean>(false);
    const [idNVYKienMacDinh, setIdNVYKienMacDinh] = useState<number | null>(null);
    const [idNVPheDuyetMacDinh, setIdNVPheDuyetMacDinh] = useState<number | null>(null);
    const [idGiamDoc, setIdGiamDoc] = useState<number | null>(null);
    const [trangThaiDon, setTrangThaiDon] = useState<number>(trangThaiDonNghiPhep.khoiTao);

    // Số ngày phép của một năm còn lại sau khi trừ các đơn đã nghỉ, đã duyệt chờ chấm công và đang chờ duyệt (chưa tính đơn hiện tại)
    const soNgayPhepConLai = (item: NgayPhepTrongNam): number =>
        item.soNgayPhepTrongNam + item.soNgayMienGiam - item.soNgayDaNghi
        - (item.daDuyetChoChamCong || 0) - (item.dangChoDuyet || 0);

    // Kiểm tra một ngày có trùng với ngày trong danh sách ngày nghỉ lễ / ngày làm bù hay không
    const trungNgayNghi = (ngay: dayjs.Dayjs, ds: Array<NgayNghiInfo>): boolean => {
        for (const item of ds) {
            if (item.lapHangNam == 1) {
                if (ngay.date() == item.ngayThang.date() && ngay.month() == item.ngayThang.month()) return true;
            } else {
                if (ngay.date() == item.ngayThang.date() && ngay.month() == item.ngayThang.month() && ngay.year() == item.ngayThang.year()) return true;
            }
        }
        return false;
    }

    // Đếm số ngày làm việc trong khoảng [tuNgay, denNgay]: trừ ngày nghỉ trong tuần (trừ ngày làm bù) và ngày nghỉ lễ.
    // Nghỉ thai sản / nghỉ BHXH tính theo ngày liên tục nên không trừ ngày nghỉ.
    const demNgayLamViec = (tuNgay: dayjs.Dayjs, denNgay: dayjs.Dayjs, idLoai: number): number => {
        if (!tuNgay.isValid() || !denNgay.isValid() || denNgay.isBefore(tuNgay, 'day')) return 0;
        let ngay = tuNgay.startOf('day');
        const ngayCuoi = denNgay.startOf('day');
        let count = ngayCuoi.diff(ngay, 'day') + 1;
        if (idLoai == loaiNghiPhep.nghiThaiSan || idLoai == loaiNghiPhep.nghiBHXH) return count;
        while (ngay.isBefore(ngayCuoi) || ngay.isSame(ngayCuoi)) {
            if (ngayNghiTrongTuan.includes(ngay.day())) {
                // Ngày nghỉ trong tuần nhưng là ngày làm bù thì vẫn tính là ngày làm việc
                if (!trungNgayNghi(ngay, dsNgayLamBu)) count--;
            } else if (trungNgayNghi(ngay, dsNgayNghiLe)) {
                count--;
            }
            ngay = ngay.add(1, 'day');
        }
        return count;
    }

    // Số ngày của đơn nằm trong thời hạn được sử dụng phép của một năm (TuNgay - DenNgay của năm phép đó),
    // ví dụ phép năm 2025 chỉ được nghỉ đến hết 31/03/2026.
    const soNgayDonTrongHanPhep = (item: NgayPhepTrongNam): number => {
        const tuNgayDon = dayjs(form.getFieldValue('tuNgay'));
        const denNgayDon = dayjs(form.getFieldValue('denNgay'));
        const tuNgayHan = dayjs(item.tuNgay);
        const denNgayHan = dayjs(item.denNgay);
        return demNgayLamViec(
            tuNgayHan.isAfter(tuNgayDon, 'day') ? tuNgayHan : tuNgayDon,
            denNgayHan.isBefore(denNgayDon, 'day') ? denNgayHan : denNgayDon,
            idLoaiNghiPhep);
    }

    // Phân bổ số ngày của đơn đang lập vào từng năm phép: ưu tiên dùng hết phép của năm cũ trước,
    // nhưng chỉ trừ được những ngày nghỉ nằm trong thời hạn sử dụng phép của năm đó và không quá số phép còn lại.
    // Phần còn thiếu trừ tiếp vào năm mới nhất (có thể âm để cảnh báo vượt quá số phép được hưởng).
    // Đơn đã trình / đang lấy ý kiến đã nằm trong cột "Đang chờ duyệt" nên không phân bổ lại.
    const tinhPhanBoDonHienTai = (): { [nam: number]: number } => {
        const kq: { [nam: number]: number } = {};
        if (dsNgayPhepTrongNam.length == 0) return kq;
        let conPhaiTru = (trangThaiDon == trangThaiDonNghiPhep.trinh || trangThaiDon == trangThaiDonNghiPhep.yKien) ? 0 : tongSoNgayNghi;
        // dsNgayPhepTrongNam được sắp xếp theo năm giảm dần nên duyệt ngược lại để trừ vào năm cũ trước
        for (let i = dsNgayPhepTrongNam.length - 1; i > 0; i--) {
            const item = dsNgayPhepTrongNam[i];
            const truVaoNam = Math.min(conPhaiTru, Math.max(0, soNgayPhepConLai(item)), soNgayDonTrongHanPhep(item));
            kq[item.nam] = truVaoNam;
            conPhaiTru -= truVaoNam;
        }
        kq[dsNgayPhepTrongNam[0].nam] = conPhaiTru;
        return kq;
    }

    const phanBoDonHienTai = tinhPhanBoDonHienTai();

    const soNgayDonHienTai = (item: NgayPhepTrongNam): number => phanBoDonHienTai[item.nam] || 0;

    const soNgayConKhaDung = (item: NgayPhepTrongNam): number =>
        soNgayPhepConLai(item) - soNgayDonHienTai(item);

    // Kiểm tra đơn có vượt quá số ngày phép còn lại hay không, trả về thông báo lỗi nếu vượt
    const kiemTraVuotPhep = (): string | null => {
        if (dsNgayPhepTrongNam.length == 0) {
            return "Thông tin cấu hình ngày phép chưa có. Vui lòng liên hệ quản trị cập nhật";
        }
        if (idLoaiNghiPhep != loaiNghiPhep.nghiPhep) return null;
        const dsVuot = dsNgayPhepTrongNam.filter((item) => soNgayConKhaDung(item) < 0);
        if (dsVuot.length == 0) return null;
        return dsVuot
            .map((item) => `Số ngày nghỉ của đơn vượt quá số ngày phép còn lại của năm ${item.nam} là ${Math.abs(soNgayConKhaDung(item))} ngày`)
            .join('. ') + ". Vui lòng kiểm tra lại.";
    }

    function onFinish(values: any) {
        const loiVuotPhep = kiemTraVuotPhep();
        if (loiVuotPhep != null) {
            toast.error(loiVuotPhep);
            setTrinhLanhDao(false);
            return;
        }
        setConfirmModal({
            isShowModal: true,
            title: trinhLanhDao ? "Lưu & Gửi phê duyệt đơn nghỉ phép" : "Lưu đơn nghỉ phép",
            content: trinhLanhDao ? <>Bạn có muốn <label>Lưu & Gửi phê duyệt</label> đơn nghỉ phép này không?</> :
                <>Bạn có muốn <label>Lưu</label> đơn nghỉ phép này không?</>,
            onSubmit: () => { eventSave(); }
        });
    }

    const demSoNgayNghi = async () => {
        setIsLoading(true);
        let startDate = dayjs(form.getFieldValue('tuNgay'));
        let endDate = dayjs(form.getFieldValue('denNgay'));
        if (startDate.isBefore(endDate) || startDate.isSame(endDate)) {
            if (form.getFieldValue('tuNgay') != null && form.getFieldValue('tuNgay') != undefined && form.getFieldValue('denNgay') != null && form.getFieldValue('denNgay') != undefined) {
                let count = endDate.diff(startDate, 'day') + 1;
                if (!Number.isNaN(count)) {
                    var rs = await layDsNghiPhepTrongNamTheoNhanVien(form.getFieldValue('tuNgay'), form.getFieldValue('denNgay'), user.idNhanVien);
                    var namTuNgay = startDate.$y;
                    var namDenNgay = endDate.$y;
                    if ((rs || []).length == 0) {
                        var namStr = namTuNgay != namDenNgay ? `năm ${namTuNgay} hoặc năm ${namDenNgay}` : `năm ${namDenNgay}`;
                        toast.error(`Thông tin cấu hình ngày phép trong ${namStr} chưa có. Vui lòng liên hệ quản trị cập nhật`);
                        setDSNgayPhepTrongNam([]);
                    } else {
                        setDSNgayPhepTrongNam(rs);
                    }
                    count = demNgayLamViec(startDate, endDate, form.getFieldValue("idLoaiNghiPhep"));
                    setTongSoNgayNghi(count);
                } else {
                    setTongSoNgayNghi(0);
                }
            }
        } else {
            form.setFieldValue('denNgay', null);
            setTongSoNgayNghi(0);
        }

        setIsLoading(false);
    }

    const onTrinh = () => {
        setTrinhLanhDao(true);
    }

    const eventSave = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen())
            setIsLoading(true);
            try {
                var request: any = {
                    ...values,
                    trinhLanhDao: trinhLanhDao,
                    tongSoNgayNghi: tongSoNgayNghi
                };
                if (idLoaiNghiPhep == loaiNghiPhep.nghiPhep) {
                    var namNay = dsNgayPhepTrongNam[0];
                    var namTruoc = dsNgayPhepTrongNam.length == 2 ? dsNgayPhepTrongNam[1] : null;
                    var soNgayNghiNamNay = phanBoDonHienTai[namNay.nam] || 0;
                    var soNgayNghiNamTruoc = namTruoc != null ? (phanBoDonHienTai[namTruoc.nam] || 0) : 0;
                    request.tongSoNgayNghi_NamNay = soNgayNghiNamNay;
                    request.tongSoNgayNghi_NamTruoc = soNgayNghiNamTruoc;
                    request.namNay = namNay.nam;
                    request.namTruoc = namTruoc != null ? namTruoc.nam : 0;
                    request.soNgayDaNghi_NamNay = namNay.soNgayDaNghi;
                    request.soNgayDaNghi_NamTruoc = namTruoc != null ? namTruoc.soNgayDaNghi : 0;
                }

                const id = await luuDonNghiPhep(request);
                toast.success(trinhLanhDao ? "Lưu và gửi phê duyệt đơn nghỉ phép thành công" : "Lưu đơn nghỉ phép thành công");
                navigate(Links.Phep.Xem + "?id=" + id);
            } catch (error: any) {
                toast.error(error);
            }
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
            dispatch(hideLoadingScreen());
        });
    }

    const layThongTinNgayNghiTrongTuan = async () => {
        var rs = await layNgayNghiTrongTuan();
        setNgayNghiTrongTuan(rs);
        var a = await layDSNgayNghiLe();
        setDsNgayNghiLe(a.filter((x) => x.idLoaiNgayNghi != loaiNgayNghi.lamBu));
        setDsNgayLamBu(a.filter((x) => x.idLoaiNgayNghi == loaiNgayNghi.lamBu));
    }

    const disableDenNgay = (current: any) => {
        const today = form.getFieldValue('tuNgay');
        return current && current < today;
    }
    const layDuLieu = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            let kq = await layChiTiet(id);
            if (kq.trangThai != trangThaiDonNghiPhep.khoiTao && !kq.quyenSua) {
                toast.error('Trạng thái không hợp lệ để chỉnh sửa!');
                navigate(Links.Phep.DanhSachDangKy);
            }
            let startDate = dayjs(dateCommon.formatDate(kq.tuNgay), "DD/MM/YYYY");
            let endDate = dayjs(dateCommon.formatDate(kq.denNgay), "DD/MM/YYYY");
            form.setFieldsValue({
                id: kq.id,
                tuNgay: startDate,
                denNgay: endDate,
                kinhGui: kq.kinhGui || "",
                lyDo: kq.lyDo || "",
                diaDiemNghiPhep: kq.diaDiemNghiPhep || "",
                idLoaiNghiPhep: kq.idLoaiNghiPhep,
                idNguoiDuyet: kq.idNguoiDuyet,
                idNguoiYKien1: kq.idNguoiYKien1,
                idNguoiYKien2: kq.idNguoiYKien2,
                idNguoiYKien3: kq.idNguoiYKien3
            });
            if (kq.idLoaiNghiPhep == loaiNghiPhep.nghiKhongLuong || kq.idLoaiNghiPhep == loaiNghiPhep.nghiThaiSan || kq.idLoaiNghiPhep == loaiNghiPhep.nghiOm || kq.idLoaiNghiPhep == loaiNghiPhep.nghiBHXH) {
                setEnsabledNYK2(true);
            }
            if (kq.idLoaiNghiPhep == loaiNghiPhep.nghiBHXH) {
                setEnsabledNYK3(true);
            }
            setTongSoNgayNghi(kq.tongSoNgayNghi);
            setIdLoaiNghiPhep(kq.idLoaiNghiPhep);
            setTrangThaiDon(kq.trangThai);
            if (startDate.isBefore(endDate) || startDate.isSame(endDate)) {
                let count = endDate.diff(startDate, 'day') + 1;
                if (!Number.isNaN(count)) {
                    var rs = await layDsNghiPhepTrongNamTheoNhanVien(kq.tuNgay, kq.denNgay, user.idNhanVien);
                    var namTuNgay = startDate.year;
                    var namDenNgay = endDate.year;
                    if (rs == null) {
                        var namStr = namTuNgay != namDenNgay ? `năm ${namTuNgay} hoặc năm ${namDenNgay}` : `năm ${namDenNgay}`;
                        toast.error(`Thông tin cấu hình ngày phép trong ${namStr} chưa có. Vui lòng liên hệ quản trị cập nhật`);
                        setDSNgayPhepTrongNam([]);
                    } else {
                        setDSNgayPhepTrongNam(rs);
                    }
                }
            }
            dispatch(hideLoadingScreen());
        } catch (err) {
            toast.error('Đơn nghỉ phép không tồn tại hoặc bạn không có quyền chỉnh sửa!');
            navigate(Links.Phep.DanhSachDangKy);
            dispatch(hideLoadingScreen());
        }
    }

    const layNguoiMacDinh = async () => {
        dispatch(showLoadingScreen());
        var rs = await layNguoiPheDuyet_YKienPhepMacDinh();
        setIdNVYKienMacDinh(rs.idNhanVienYKien > 0 ? rs.idNhanVienYKien : null);
        setIdNVPheDuyetMacDinh(rs.idNhanVienDuyet > 0 ? rs.idNhanVienDuyet : null);
        setIdGiamDoc(rs.idGiamDoc > 0 ? rs.idGiamDoc : null);
        form.setFieldsValue({
            id: 0,
            kinhGui: "",
            lyDo: "",
            diaDiemNghiPhep: "",
            idNguoiDuyet: rs.idNhanVienDuyet > 0 ? rs.idNhanVienDuyet : null,
            idNguoiYKien1: rs.idNhanVienYKien > 0 ? rs.idNhanVienYKien : null
        });
        if (rs.idNhanVienYKien > 0) {
            setIdNguoiYKien(rs.idNhanVienYKien);
        }
        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        layThongTinNgayNghiTrongTuan();
        if (id > 0) {
            layDuLieu(id);
        } else {
            layNguoiMacDinh();
        }
    }, []);

    return (
        <section>
            <ContentHeader title="Đăng ký nghỉ phép" />
            <Form
                layout="vertical"
                onFinish={onFinish}
                onSubmitCapture={(e) => e.preventDefault()}
                validateMessages={validateMessages}
                form={form}
            >
                <Row>
                    <Col span="24">
                        <div className="card-outline">
                            <Tabs
                                tabBarExtraContent={
                                    <Space style={{ position: "fixed", zIndex: 1, right: "25px", top: "120px" }}>
                                        <Button
                                            loading={isLoading}
                                            type="primary"
                                            htmlType="submit"
                                            icon={<SendOutlined rev="" />}
                                            onClick={onTrinh}
                                        >
                                            Lưu & Gửi phê duyệt
                                        </Button>
                                        <Button
                                            loading={isLoading}
                                            type="primary"
                                            icon={<SaveOutlined rev="" />}
                                            htmlType="submit"
                                        >
                                            Lưu
                                        </Button>
                                    </Space>}
                                defaultActiveKey="1" items={[
                                    {
                                        key: "1",
                                        label: <span>Thông tin</span>,
                                        children:
                                            <Row>
                                                <Col span="24" className="card card-body">
                                                    <Form.Item
                                                        name="id"
                                                        hidden
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Row gutter={24}>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Nhân viên"
                                                            >
                                                                {tenNhanVien}
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                                name="idLoaiNghiPhep" label="Loại nghỉ">
                                                                <LoaiNghiPhepSelectBox onChange={async (e: any) => {
                                                                    setIdLoaiNghiPhep(e.target.value);
                                                                    form.setFieldValue('idLoaiNghiPhep', e.target.value);
                                                                    if (e.target.value == loaiNghiPhep.nghiThaiSan || e.target.value == loaiNghiPhep.nghiKhongLuong || e.target.value == loaiNghiPhep.nghiOm || e.target.value == loaiNghiPhep.nghiBHXH) {
                                                                        setEnsabledNYK2(true);
                                                                        form.setFieldValue("idNguoiYKien1", idNVYKienMacDinh);
                                                                        form.setFieldValue("idNguoiDuyet", idGiamDoc);
                                                                        if (idGiamDoc != idNVPheDuyetMacDinh) {
                                                                            form.setFieldValue("idNguoiYKien2", idNVPheDuyetMacDinh);
                                                                        }
                                                                        if (e.target.value == loaiNghiPhep.nghiBHXH) {
                                                                            setEnsabledNYK3(true);
                                                                        } else {
                                                                            setEnsabledNYK3(false);
                                                                            form.setFieldValue("idNguoiYKien3", null);
                                                                        }
                                                                    } else {
                                                                        setEnsabledNYK2(false);
                                                                        form.setFieldValue("idNguoiYKien1", idNVYKienMacDinh);
                                                                        form.setFieldValue("idNguoiDuyet", idNVPheDuyetMacDinh);
                                                                        form.setFieldValue("idNguoiYKien2", null);
                                                                        setEnsabledNYK3(false);
                                                                        form.setFieldValue("idNguoiYKien3", null);
                                                                    }
                                                                    demSoNgayNghi();
                                                                }} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Địa điểm nghỉ phép"
                                                                name="diaDiemNghiPhep"
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Kính gửi"
                                                                name="kinhGui"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <TextArea rows={2} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="16">
                                                            <Form.Item
                                                                label="Lý do"
                                                                name="lyDo"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <TextArea rows={2} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span={8}>
                                                            <Form.Item name="idNguoiYKien1" label={enabledNYK2 ? "Người ý kiến 1" : "Người ý kiến"}>
                                                                <NhanVienPhongBanSelectBox idDonVi={user.idDonVi} allowClear onChange={(e: any) => { form.setFieldValue('idNguoiYKien1', e.target.value); }} idNhanVienAdd={idNguoiYKien} />
                                                            </Form.Item>
                                                        </Col>
                                                        {
                                                            enabledNYK2 &&
                                                            <Col span={8}>
                                                                <Form.Item name="idNguoiYKien2" label="Người ý kiến 2">
                                                                    <BanGiamDocSelectBox allowClear onChange={(e: any) => { form.setFieldValue('idNguoiYKien2', e.target.value); }} />
                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                        {
                                                            enabledNYK3 &&
                                                            <Col span={8}>
                                                                <Form.Item name="idNguoiYKien3" label="BCH Công đoàn">
                                                                        <BanChapHanhCongDoanSel allowClear onChange={(e: any) => { form.setFieldValue('idNguoiYKien3', e.target.value); }} />
                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                        <Col span={8}>
                                                            <Form.Item name="idNguoiDuyet" label="Người duyệt"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}>
                                                                <BanGiamDocSelectBox onChange={(e: any) => { form.setFieldValue('idNguoiDuyet', e.target.value); }} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Từ ngày"
                                                                name="tuNgay"
                                                                rules={[{ required: true }]}
                                                            >
                                                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Từ ngày" onChange={demSoNgayNghi} format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Đến ngày"
                                                                name="denNgay"
                                                                rules={[{ required: true }]}
                                                            >
                                                                <DatePicker changeOnBlur={true} disabledDate={disableDenNgay} onChange={demSoNgayNghi} style={{ width: "100%" }} placeholder="Từ ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Tổng số ngày nghỉ"
                                                            >
                                                                {tongSoNgayNghi} ngày làm việc
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>

                                                    {
                                                        idLoaiNghiPhep == loaiNghiPhep.nghiPhep && dsNgayPhepTrongNam.length >= 1
                                                            ? <Row gutter={24}>
                                                                <Col span="24">
                                                                    <Form.Item label="Thông tin ngày phép">
                                                                        <Table
                                                                            dataSource={dsNgayPhepTrongNam}
                                                                            rowKey={(record) => record.id}
                                                                            size="small"
                                                                            bordered
                                                                            pagination={false}
                                                                            locale={{ emptyText: "Không có dữ liệu" }}
                                                                        >
                                                                            <Column title="Năm" align="center" dataIndex="nam" key="nam" width="90px" />
                                                                            <Column title="Tổng số ngày phép" key="tongSoNgayPhep" align="right"
                                                                                render={(value: NgayPhepTrongNam) =>
                                                                                    (<span>{value.soNgayPhepTrongNam + value.soNgayMienGiam}</span>)
                                                                                } />
                                                                            <Column title="Đã nghỉ" dataIndex="soNgayDaNghi" key="soNgayDaNghi" align="right" />
                                                                            <Column title="Đã duyệt - chờ chấm công" key="daDuyetChoChamCong" align="right"
                                                                                render={(value: NgayPhepTrongNam) =>
                                                                                    (<span>{value.daDuyetChoChamCong || 0}</span>)
                                                                                } />
                                                                            <Column title="Đang chờ duyệt" key="dangChoDuyet" align="right"
                                                                                render={(value: NgayPhepTrongNam) =>
                                                                                    (<span>{value.dangChoDuyet || 0}</span>)
                                                                                } />
                                                                            <Column title="Đơn hiện tại" key="donHienTai" align="right"
                                                                                render={(value: NgayPhepTrongNam) =>
                                                                                    (<span>{soNgayDonHienTai(value)}</span>)
                                                                                } />
                                                                            <Column title="Còn khả dụng" key="conKhaDung" align="right"
                                                                                render={(value: NgayPhepTrongNam) => {
                                                                                    const conLai = soNgayConKhaDung(value);
                                                                                    return (<b style={{ color: conLai < 0 ? "#cf1322" : undefined }}>{conLai}</b>);
                                                                                }} />
                                                                        </Table>
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            : null
                                                    }
                                                </Col>
                                            </Row>
                                    }
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
            </Form>
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    confirmModal.onSubmit();
                    setConfirmModal({ isShowModal: false });
                }}
            >
                {confirmModal.content}
            </ModalTextForm>
        </section>
    );
};

export default ChiTietPhep;
